import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Products } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { FiltersProvider } from '@context';
import { useData } from '@hooks/useData';
import { useGetCampaigns } from '@services/useGetCampaigns';

export function ProductsPage() {
    const { request: requestCampaigns } = useGetCampaigns();
    const { allSettings, campaigns } = useData();
    const { t } = useTranslation();

    const params = new URLSearchParams(window.location.search);

    const campaign = params.has('campaigns_uuid')
        ? campaigns?.data?.find((campaign) => campaign.uuid === params.get('campaigns_uuid'))
        : null;

    // unique categories of all products in campaign
    const categories = (campaign?.products?.map((product) => product.category) || []).filter(
        (category, index, self) => self.indexOf(category) === index
    );

    const translations = {
        title: t('products-component.metatags.title', { marketplace: allSettings?.data?.marketplaceName }),
        description: t('products-component.metatags.description', { marketplace: allSettings?.data?.marketplaceName }),
        titleCampaign: t('products-component.metatags.title-campaign', {
            name: campaign?.title || '',
            marketplace: allSettings?.data?.marketplaceName,
        }),
        descriptionCampaign: t('products-component.metatags.description-campaign', {
            name: campaign?.title || '',
            type: categories.join(', '),
            marketplace: allSettings?.data?.marketplaceName,
        }),
    };

    const seoImage = campaign?.desktopImg;

    useSEOMetatags({
        title: campaign ? translations.titleCampaign : translations.title,
        description: campaign ? translations.descriptionCampaign : translations.description,
        image: seoImage?.src
            ? {
                  src: seoImage.src || '',
                  type: seoImage.type,
                  width: seoImage.width,
                  height: seoImage.height,
                  alt: campaign?.title || '',
              }
            : undefined,
        url: SITE_URLS.products,
        index: true,
    });

    useEffect(() => {
        !campaigns && requestCampaigns();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <FiltersProvider>
            <Products />
        </FiltersProvider>
    );
}
